import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

/* stylelint-disable */
const Wrapper = styled.div`
  padding: 5px 0px;
  input:checked {
    & + label span:first-child {
      background: ${props => props.iconColor};
      border-color: ${props => props.iconColor};
      animation: wave 0.4s ease;
      svg {
        stroke-dashoffset: 0;
      }
      &:before {
        transform: scale(3.5);
        opacity: 0;
        transition: all 0.6s ease;
      }
    }
  }
  @keyframes wave {
    50% {
      transform: scale(0.9);
    }
  }
`

const CheckLabel = styled.label`
  margin: auto;
  -webkit-user-select: none;
  user-select: none;
  cursor: pointer;
  display: flex;
  > span {
    display: inline-block;
    flex: 0 0 auto;
    vertical-align: middle;
    transform: translate3d(0, 0, 0);
    &:first-child {
      position: relative;
      width: 14px;
      height: 14px;
      border-radius: 3px;
      transform: scale(0.75);
      vertical-align: middle;
      border: 2px solid ${props => props.theme.CheckBoxLabelColor};
      transition: all 0.2s ease;
      svg {
        position: absolute;
        top: 2px;
        left: 1px;
        fill: none;
        stroke: #fff;
        stroke-width: 2;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-dasharray: 16px;
        stroke-dashoffset: 16px;
        transition: all 0.3s ease;
        transition-delay: 0.1s;
        transform: translate3d(0, 0, 0);
      }
      &:before {
        content: '';
        width: 100%;
        height: 100%;
        background: ${props => props.iconColor};
        display: block;
        transform: scale(0);
        opacity: 1;
        border-radius: 50%;
      }
    }
    &:last-child {
      padding-left: 5px;
      line-height: 20px;
      width: 90%;
    }
  }
  &:hover {
    span:first-child {
      border-color: ${props => props.iconColor};
    }
  }
`
/* stylelint-enable */

const LabelTitle = styled.span`
  font-size: 12px;
  color: ${props => props.theme.CheckBoxLabelColor};
  line-height: 14px;
  white-space: nowrap;
`

export default class CheckBox extends PureComponent {
  static propTypes = {
    labelTitle: PropTypes.string,
    iconColor: PropTypes.string,
    handleCheckChange: PropTypes.func,
    defaultChecked: PropTypes.bool,
  }

  static defaultProps = {
    labelTitle: 'Input your labelTitle',
    iconColor: '#f0b90a',
    defaultChecked: false,
    handleCheckChange: () => {},
  }

  render() {
    const { iconColor, labelTitle, handleCheckChange, defaultChecked } = this.props
    return (
      <Wrapper iconColor={iconColor}>
        <input
          id={`cbx${labelTitle}`}
          type="checkbox"
          checked={defaultChecked}
          style={{ display: 'none' }}
          onChange={handleCheckChange}
        />
        <CheckLabel htmlFor={`cbx${labelTitle}`} iconColor={iconColor}>
          <span>
            <svg width="12px" height="10px" viewBox="0 0 12 10">
              <polyline points="1.5 6 4.5 9 10.5 1" />
            </svg>
          </span>
          <LabelTitle>{labelTitle}</LabelTitle>
        </CheckLabel>
      </Wrapper>
    )
  }
}
